import { readCache } from '@/store/action';
import type { GetUserMeResponse, GetStateResponse } from '@/client';
import { getUserMeQueryKey, getStateQueryKey } from '@/client/@tanstack/react-query.gen';

export const getUserInfo = () => { //Read userInfo cache
	const data = readCache(getUserMeQueryKey()) as GetUserMeResponse
	return data
}
export const getUserState = () => { //Read user state cache
	const data = readCache(getStateQueryKey()) as GetStateResponse
	return data
}
